import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { ArrowRight } from 'lucide-react';

const CustomCard = ({
  image,
  title,
  subtitleI,
  subtitleII,
  subtitleIII,
  onClick,
  direction = 'rtl',
}) => {
  const theme = useTheme();

  return (
    <Card 
        sx={{ display: 'flex', boxShadow:"none", borderRadius:"10px", flexDirection: direction === 'rtl' ? 'row-reverse' : 'row' }} 
        className='border-2 cursor-pointer'
        onClick={onClick}>
      <Box sx={{ display: 'flex', flexDirection: 'column',  width: '60%', }} className="py-3">
        <CardContent sx={{ flex: '1 0 auto' }}>
          <div className='flex gap-2 text-lg font-bold text-gray-900 mb-1'>
            {title} <ArrowRight />
          </div>
          <div className='text-sm font-medium text-gray-500'>
            {subtitleI}
          </div>
          <div className='text-sm font-medium text-gray-500'>
            {subtitleII}
          </div>
          <div className='text-sm font-medium text-gray-500'>
            {subtitleIII}
          </div>
        </CardContent>
      </Box>
      <CardMedia
        component="img"
        sx={{ width: 151, width:"40%" }}
        image={image}
        alt={`${title} album cover`}
      />
    </Card>
  );
};

export default CustomCard;
